"use client";

import React from "react";
import { Settings as Gear, Wrench, Disc as Wheel, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  id: "01",
  title: "Service Motociclete",
  items: ["Mecanică și Întreținere", "Reparatii Motoare", "Reparatii Accidente", "Reparatii Electrice", "Diagnoză", "Customizare"],
  icon: Gear
}, {
  id: "02",
  title: "Vulcanizare",
  items: ["Schimb de Anvelope", "Echilibrare", "Îndreptare Jante"],
  icon: Wheel
}, {
  id: "03",
  title: "Detailing",
  items: ["Curățare si degresare detaliată", "Polishare", "Tratament de protecție vopsea"],
  icon: Sparkles
}, {
  id: "04",
  title: "ATV & Scootere",
  items: ["Servicii complete pentru ATV-uri și scootere: mecanică, electrică, vulcanizare și întreținere periodică."],
  icon: Wrench
}];
export default function TailoredDigitalSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223827" id="expertiza-noastră-moto" className="dark bg-black text-foreground pt-16 pb-24 lg:pt-24 lg:pb-32 overflow-hidden border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`mb-20 w-full transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-2xl font-default font-bold tracking-tighter uppercase text-white ![margin:0px_30px_24px_0px] md:text-5xl lg:text-6xl">
            Serviciile pe Care Le oferim
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-3xl leading-relaxed">
            La Pure Moto Performance, transformăm pasiunea pentru două roți în
            precizie tehnică absolută pentru siguranța ta.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 min-[769px]:grid-cols-4 gap-6 justify-center">
          {servicesData.map((service, i) => <div key={service.id} data-index={i} className={`transition-all duration-1000 delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <Card className="bg-card border-none shadow-lg hover:shadow-primary/10 transition-shadow duration-300 rounded-xl h-full">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4 text-primary">
                    <service.icon size={24} strokeWidth={2} />
                  </div>
                  <CardTitle className="text-2xl xl:text-3xl font-default font-bold text-primary">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="list-disc pl-5 space-y-2 text-sm text-muted-foreground leading-relaxed font-default marker:text-primary">
                    {service.items.map(item => <li key={item}>{item}</li>)}
                  </ul>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}